import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.p`
  position: relative;
  display: inline;
  opacity: 0.9;
  color: #d7fffc;
  font-family: 'Galano Classic';
  font-size: 194px;
  line-height: 174px;
  font-weight: 400;
  padding: 0;
  margin: 0 -7px;
  min-width: 120px;

  ${media.medium`
    font-size: 22vw;
  `}
`;
